import { render, staticRenderFns } from "./NavItemContextMenu.vue?vue&type=template&id=c9504192&"
import script from "./NavItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./NavItemContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavItemContextMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports